import { useState, useEffect  } from 'react';
import {
  Box,
  chakra,
  Container,
  Stack,
  Text,
  Image,
  Flex,
  VStack,
  Button,
  Heading,
  SimpleGrid,
  StackDivider,
  useColorModeValue,
  VisuallyHidden,
  List,
  ListItem,
  useBreakpointValue,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
  Center,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Alert,
  AlertIcon,
  useToast,
} from '@chakra-ui/react';
import { FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import { MdLocalShipping } from 'react-icons/md';
import Reviews from './Reviews';

import Accord from './Accord';
import CardGrid from './CardGrid';

import { Link } from 'react-router-dom';
import NewNavbar from '../Nav/NewNavbar';
import Contact from '../Sections/Footer';

import {useNavigate} from 'react-router-dom';

import Login from '../Login';

import axios from 'axios';

export default function ProductCompo(props) {
  const { title, price, description, features, details, breadcrumbs, major, words } = props;
  const imageMargin = useBreakpointValue({ base: '60px', lg: '100px' });


  const token = localStorage.getItem('token');

  const formData = {
    sopType : major,
    sopSubType :title,
    words:words,
    price : price,
    paymentStatus: false,
  }

  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const toast = useToast();
  const handleClick = async () => {
    if (localStorage.getItem("token") == null) {
      setShowLoginModal(true);
    } else {
      const orderId = await axios.get('http://localhost:3000/sop/review',{params: {formData: formData}, withCredentials:true}).then(
        result => {
        console.log(result.data)
        return result.data}
        )
        .catch(
        err => console.log(err)
        );
        console.log(orderId.data)
      navigate('/payment', { state: { orderId: orderId.data } });

    }
  };


  return (
    <>
    <NewNavbar/>
      <Container maxW={'7xl'}>
        <SimpleGrid
          columns={{ base: 1, lg: 2 }}
          spacing={{ base: 8, md: 10 }}
          py={{ base: 18, md: 24 }}
        >
          <Flex marginTop={imageMargin}>
            <Image
              rounded={'md'}
              alt={'product image'}
              src={
                'https://images.unsplash.com/photo-1525921429624-479b6a26d84d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80'
              }
              fit={'cover'}
              align={'center'}
              w={'100%'}
              h={{ base: '100%', sm: '400px', lg: '500px' }}
            />
          </Flex>
          <Stack spacing={{ base: 6, md: 10 }}>
            <Box as={'header'}>
              <Heading
                lineHeight={1.1}
                fontWeight={600}
                fontSize={{ base: '2xl', sm: '4xl', lg: '5xl' }}
              >
                {title}
              </Heading>
              <Text
                color={useColorModeValue('gray.900', 'gray.400')}
                fontWeight={300}
                fontSize={'2xl'}
              >
                {price}
              </Text>
              <div>
                <Breadcrumb>
                  {breadcrumbs.map((breadcrumb, index) => (
                    <BreadcrumbItem
                      key={index}
                      isCurrentPage={breadcrumb.isCurrentPage}
                    >
                      {breadcrumb.isCurrentPage ? (
                        <BreadcrumbLink color="green.500">
                          {breadcrumb.label}
                        </BreadcrumbLink>
                      ) : (
                        <BreadcrumbLink href={breadcrumb.href}>
                          {breadcrumb.label}
                        </BreadcrumbLink>
                      )}
                    </BreadcrumbItem>
                  ))}
                </Breadcrumb>
              </div>
            </Box>

            <Stack
              spacing={{ base: 4, sm: 6 }}
              direction={'column'}
              divider={
                <StackDivider
                  borderColor={useColorModeValue('gray.200', 'gray.600')}
                />
              }
            >
              <VStack spacing={{ base: 4, sm: 6 }}>
                <Text
                  color={useColorModeValue('gray.500', 'gray.400')}
                  fontSize={'2xl'}
                  fontWeight={'300'}
                >
                  {description}
                </Text>
                <Text fontSize={'lg'}>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad
                  aliquid amet at delectus doloribus dolorum expedita hic, ipsum
                  maxime modi nam officiis porro, quae, quisquam quos
                  reprehenderit velit? Natus, totam.
                </Text>
              </VStack>
              {/* <Box>
              <Text
                fontSize={{ base: '16px', lg: '18px' }}
                color={useColorModeValue('yellow.500', 'yellow.300')}
                fontWeight={'500'}
                textTransform={'uppercase'}
                mb={'4'}
              >
                Features
              </Text>

              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
                <List spacing={2}>
                  {features.map((feature, index) => (
                    <ListItem key={index}>{feature}</ListItem>
                  ))}
                </List>
              </SimpleGrid>
            </Box> */}
              <Box>
                <Text
                  fontSize={{ base: '16px', lg: '18px' }}
                  color={useColorModeValue('yellow.500', 'yellow.300')}
                  fontWeight={'500'}
                  textTransform={'uppercase'}
                  mb={'4'}
                >
                  Product Details
                </Text>

                <List spacing={2}>
                  {details.map((detail, index) => (
                    <ListItem key={index}>
                      <Text as={'span'} fontWeight={'bold'}>
                        {detail.label}:
                      </Text>{' '}
                      {detail.value}
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Stack>

            <Button

              onClick={handleClick}
              rounded={'none'}
              w={'full'}
              mt={8}
              size={'lg'}
              py={'7'}
              bg={useColorModeValue('gray.900', 'gray.50')}
              color={useColorModeValue('white', 'gray.900')}
              textTransform={'uppercase'}
              _hover={{
                transform: 'translateY(2px)',
                boxShadow: 'lg',
              }}
            >
              Purchase Now
            </Button>
          </Stack>
        </SimpleGrid>
      </Container>

      {showLoginModal && (
        <Modal isOpen={showLoginModal} onClose={() => setShowLoginModal(false)}>
          <ModalOverlay />
          <ModalContent>
            <ModalCloseButton />
            <ModalBody>
              <Login onClose={() => setShowLoginModal(false)} />
            </ModalBody>
          </ModalContent>
        </Modal>
      )}

      <Center>
        <Stack
          direction={['column', 'column', 'row']} // Vertical stack on mobile, horizontal stack on desktop
          spacing={[1, 1, 20]}
        >
          <CardGrid
            image="https://media.istockphoto.com/id/1371896323/photo/graduation-day-back-view-of-asian-woman-with-graduation-cap-and-coat-holding-diploma-success.jpg?s=612x612&w=0&k=20&c=kQC8vjAMstItxUgQC4q2L8LQLuOaCvrmo5_HgoXp_ok="
            heading="Select The Best"
            text="If you need professional essay editing for your task, we have a complete catalog of experts for you to choose from! It does not matter if it is your first time ordering or if you have used our services many times before; we want to make the process of finding an editor as straightforward as possible."
          />
          <CardGrid
            image="https://images.unsplash.com/photo-1517971071642-34a2d3ecc9cd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=388&q=80"
            heading="Top-Notch Edit"
            text="Struggling to stay on top of higher education, work, social, and family commitments? Dealing with all these daily responsibilities can be extremely difficult, which is exactly why we set up this business. Through hundreds of qualified and motivated experts, we aim to help you with your educational tasks, alleviate stress, and also help you gain knowledge that you can apply to all your other assignments."
          />
          <CardGrid
            image="https://images.unsplash.com/photo-1607013407627-6ee814329547?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=964&q=80"
            heading="Admit to dream school"
            text="We do our utmost to ensure that the interaction customers have with our paper editing service is always a positive one. Of course, our experts play a huge part in this, with high-quality detailed work and excellent communication. Yet, there is also the fact that our platform is easy-to-use, and customer support is on-hand 24/7."
          />
        </Stack>
      </Center>

      <Accord />
      <Reviews />
      <Contact/>
    </>
  );
}
